import type { RefObject } from "react"
import { useEventListener } from "usehooks-ts"

export function useClickOutside(
	ref: RefObject<HTMLElement | null>,
	open: boolean,
	onClose: () => void,
) {
	useEventListener(
		"mousedown",
		(e: MouseEvent) => {
			if (open && ref.current && !ref.current.contains(e.target as Node)) {
				onClose()
			}
		},
		undefined,
		{ passive: true },
	)
}
